import { type NextPageWithLayout } from 'next'
import React from 'react'
import { Box, Container } from 'components/Layout'
import Link from 'components/Link'
import Logo from 'components/Logo'
import { H4 } from 'components/Typography'
import { ROUTE } from 'constants/routes'
import { withRedirect } from 'hoc/withRedirect'
import { COLOR_INTENT, SPACE } from 'Theme'
import { SignInTabs } from './SignInTabs'

const SignInPage: NextPageWithLayout = () => (
  <Box
    minHeight="100vh"
    pb={{ MOBILE: SPACE.PX_60 }}
    backgroundColor={COLOR_INTENT.SIGN_IN.BACKGROUND}
  >
    <Container.Small
      px={{ MOBILE: SPACE.PX_15, TABLET: 0 }}
      flexDirection="column"
      alignItems="center"
    >
      <Box mt={{ MOBILE: 0, TABLET: SPACE.PX_20 }} mb={SPACE.PX_20}>
        <Link href={ROUTE.FRONT_PAGE()} aria-label="home">
          <Logo />
        </Link>
      </Box>
      <H4 mb={SPACE.PX_30}>Sign in</H4>
      <SignInTabs />
    </Container.Small>
  </Box>
)

SignInPage.seoProps = {
  description:
    "Sign in or create new account to enjoy video consultations with the world's top Experts.",
}

export default withRedirect({
  isWithReturnUrl: true,
  redirectRouteForAll: false,
})(SignInPage)
